var CookieConsent = (function($) {
	// var focusTrap = require('focus-trap') // this is loaded via window.focusTrap external script tag

	// The below code is used for "cookie-law-info" version 3
	window.focusTrapBanner = null;
	window.focusTrapModal = null;
	window.focusTrapOptions = {
		allowOutsideClick: true,
	};

	function events() {
		var consentBar = document.querySelector( '.cky-consent-bar' );
		if ( ! consentBar ) {return;}

		// Banner
		changeBannerTitleToH2();
		closeBannerOnEscapeUp();
		trapFocusInBanner();

		// Modal
		changeModalTitleToH2();
		addAriaExpandedToAccordions();
		closeModalOnEscapeUp();
		changeAriaLabelCloseBtnModal();
		observeModal();

		// Page
		changeEmbedText();
	}


	/**
	 * Transform the tag of an element to another tag, e.g. <p> to <h2>.
	*
	* @param {HTMLElement} element     The element to transform
	* @param {string}  transformTo Tag to transform to (e.g. 'h2')
	* @return {HTMLElement|null} Transformed element
	*/
	function transformTag (
		element,
		transformTo
		) {
			if ( ! element ) {return null};
		var transformedElement = document.createElement( transformTo );

		transformedElement.innerHTML = element.innerHTML;

		for ( var i = 0; i < element.attributes.length; i++ ) {
			transformedElement.setAttribute(
				element.attributes[ i ].name,
				element.attributes[ i ].value
			);
		}

		if ( ! element.parentNode ) {return null};

		element.parentNode.replaceChild( transformedElement, element );

		return transformedElement;
	};


	/**
	 * A11y: transform modal title to h2
	 */
	function changeBannerTitleToH2() {
		var title = document.querySelector( '.cky-title' );
		transformTag( title, 'h2' );
	}

	/**
	 * A11y: close banner on escape key
	 */
	function closeBannerOnEscapeUp() {
		document.addEventListener( 'keyup',function ( e ) {
			if ( e.key === 'Escape' ) {
				var closeButton = document.querySelector(
					'.cky-banner-btn-close'
				);

				if ( ! closeButton ) {return;}
				closeButton.click();

				if( ! window.focusTrapBanner ){return;}

				window.focusTrapBanner.deactivate();
			}
		} );
	}

	/**
	 * A11y: trap focus in banner when the accept all button is focused
	 */
	function trapFocusInBanner() {
		var customizeButton = document.querySelector( '.cky-btn-accept' );

		if ( ! customizeButton ) {return;}

		customizeButton.addEventListener( 'focus', function(){
			window.focusTrapBanner = window.focusTrap.createFocusTrap(
				'.cky-consent-bar',
				focusTrapOptions
			);
			if(window.focusTrapBanner){
				focusTrapBanner.activate();
			}
		} );
	}

	/**
	 * A11y: transform modal title to h2
	 */
	function changeModalTitleToH2() {
		var title = document.querySelector(
			'.cky-preference-title'
		);
		transformTag( title, 'h2' );
	}

	/**
	 * A11y: close modal on escape key
	 */
	function closeModalOnEscapeUp() {
		document.addEventListener( 'keyup', function( event ){
			if ( event.key === 'Escape' ) {
				var closeButton = document.querySelector(
					'.cky-modal.cky-modal-open .cky-btn-close'
				);

				if ( ! closeButton ) {return;}
				closeButton.click();

				if(! window.focusTrapModal ){return;}
				focusTrapModal.deactivate();
			}
		} );
	}

	/**
	 * A11y: observe accordions for changes to update aria-expanded
	 */
	function addAriaExpandedToAccordions() {
		var accordions = document.querySelectorAll( '.cky-accordion' );

		accordions.forEach( function( wrapper ) {
			var button = wrapper.querySelector( '.cky-accordion-btn' );

			button.setAttribute( 'aria-expanded', 'false' );

			var observer = new MutationObserver( function( mutations )  {
				mutations.forEach( function( mutation )  {
					if ( mutation.type === 'attributes' ) {
						button.setAttribute(
							'aria-expanded',
							wrapper.classList.contains(
								'cky-accordion-active'
							)
								? 'true'
								: 'false'
						);
					}
				} );
			} );

			observer.observe( wrapper, {
				attributes: true,
			} );
		} );
	}

	/**
	 * A11y: Change aria-label close button in modal
	 */
	function changeAriaLabelCloseBtnModal() {
		var closeButton = document.querySelector( '.cky-btn-close' );
		if ( ! closeButton ) {return;}

		closeButton.setAttribute( 'aria-label', 'Sluit' );
	}

	/**
	 * A11y: Observes the cookie modal for changes
	 */
	function observeModal() {
		var cookieModal = document.querySelector( '.cky-modal' );
		if ( ! cookieModal ) {return;}

		var observer = new MutationObserver( function( mutations ){
			mutations.forEach( function( mutation ) {
				if ( mutation.attributeName === 'class' ) {
					// If the modal opens
					if (
						mutation.attributeName === 'class' &&
						mutation.target.classList.contains( 'cky-modal-open' )
					) {
						setTimeout( function() {
							window.focusTrapModal =
								window.focusTrap.createFocusTrap( '.cky-modal' );
								if(window.focusTrapModal){
									focusTrapModal.activate();
								}
						}, 200 );
					}

					// If the modal closes
					if (
						mutation.attributeName === 'class' &&
						! mutation.target.classList.contains( 'cky-modal-open' )
					) {
						if(window.focusTrapModal){
							focusTrapModal.deactivate();
						}
					}
				}
			} );
		} );

		observer.observe( cookieModal, {
			attributes: true,
		} );
	}

	/**
	 * Make the accept text which appears when the user has not accepted cookies accessible
	 * like a button. Changing the <p> to a <button> will lose the event listener.
	 */
	function changeEmbedText() {
		var acceptText = document.querySelectorAll(
			'[data-cky-tag="placeholder-title"]'
		);

		acceptText.forEach( function( text ) {
			var button = transformTag( text, 'button' );

			button.addEventListener( 'click', function() {
				window._revisitCkyConsent();
			} );
			button.addEventListener( 'keyup', function( e ) {
				if ( e.key === 'Enter' ) {
					window._revisitCkyConsent();
				}
			} );
		} );
	}

	var init = function() {
		setTimeout( function() {events()}, 500 ); // Put this function last on the call stack to work properly
	};

	return {
		init: init
	}

})(jQuery);


// import * as focusTrap from 'focus-trap';
// import { transformTag } from './a11y';




// export default CookieConsent;
